"use strict";

// Step 1: Define a variable to hold the screen width
let screenWidth = window.innerWidth;
let cellGroup = 1;

// Step 2: Create a function to update the screen width variable
function updateScreenWidth() {
    screenWidth = window.innerWidth;
    // console.log("Screen width updated:", screenWidth);
}

// Step 3: Attach an event listener to the window's resize event
window.addEventListener('resize', updateScreenWidth);

// Initial call to set the variable with the current screen width
updateScreenWidth();

if(screenWidth < 490) {
  cellGroup = 2
} else {
  cellGroup = 1
}

Shopify.theme.jsFeaturedPromos = {
  init: function init($section) {
    // Selectors
    var $prevButton = $section.find('.featured-promotions__nav--prev');
    var $nextButton = $section.find('.featured-promotions__nav--next');
    var $promoSlider = $section.find('[data-featured-promotions-slider]');
    var $featuredPromosSlider = $promoSlider.flickity({
      initialIndex: 1,
      contain: true,
      wrapAround: true,
      prevNextButtons: true,
      pageDots: true,
      imagesLoaded: true,
      draggable: true,
      groupCells: cellGroup,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $featuredPromosSlider.flickity('resize');
          }, 500);
        }
      },
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
    });
    // $prevButton.on('click', function () {
    //   $featuredPromosSlider.flickity('previous');
    // });
    // $nextButton.on('click', function () {
    //   $featuredPromosSlider.flickity('next');
    // });
  },
  blockSelect: function blockSelect($section, blockId) {
    var $featuredPromosSlider = $section.find('[data-featured-promotions-slider]');
    var slideIndex = $('#shopify-section-' + blockId).data('promo-index');
    $featuredPromosSlider.flickity('select', slideIndex, true, true);
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
    $('.featured-promotions__nav--prev').off();
    $('.featured-promotions__nav--next').off();
  }
};
